import React from "react";

const Reviews = () => {
    return(
        <>
        
   {/* <!-- Review start  --> */}
   <div class="py-5 my-3 bg-dark text-white">
       <div class="text-center text-white">
           <h2>REVIEWS</h2>
           <hr class="text-center w-25 mx-auto" />
           <p class="text-center ">What people say about us</p>
           <p class="py-5 text-center">This was my first experience with that team and outperformed my expectation! They know there stuff 
               <br/>and I highly recommend them!  A+++.</p>
            <h6>Daryl Hodgeman</h6>
       </div>

   </div>
   {/* <!-- Review end  --> */}

    

        </>
    );
};

export default Reviews;